export const environment = {
  production: true,
  URL_API: 'https://dm.qainformatica.com.mx/api/v2',
  service: 'proinvel',
  APIKEY: '32df4c6d5d573283abadb9cc699d727cb66d4e4004bc87bdc94822fc74065635',
  version: 'PROD-23-03-2026.9'
};



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/environments/environment.ts